import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useTranslation } from "react-i18next"
import { ArrowRight, Play } from "@solar-icons/react"

export function HeroSection() {
  const { t } = useTranslation("marketing")

  return (
    <section className="relative overflow-hidden py-20 sm:py-32">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(45%_40%_at_50%_60%,rgba(20,184,166,0.1),transparent)]" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">

          <h1 className="text-4xl font-bold tracking-tight sm:text-6xl">
            {t("hero.title")}{" "}
            <span className="bg-gradient-to-r from-teal-500 to-cyan-600 bg-clip-text text-transparent">{t("hero.titleHighlight")}</span>
          </h1>
          <p className="mt-6 text-lg text-muted-foreground sm:text-xl">
            {t("hero.subtitle")}
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" className="rounded-full bg-gradient-to-r from-teal-500 to-cyan-600 hover:from-teal-600 hover:to-cyan-700 text-white border-0" asChild>
              <Link to="/sign-up">
                {t("hero.startTrial")}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="rounded-full border-teal-200 hover:bg-teal-50 dark:border-teal-800 dark:hover:bg-teal-950/50" asChild>
              <Link to="/solutions">
                <Play className="mr-2 h-5 w-5 text-teal-600" />
                {t("hero.seeHowItWorks")}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
